var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53656 1.60229V3.02613",
    stroke: "white",
    strokeWidth: 1.16496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9048 1.60229V3.02613",
    stroke: "white",
    strokeWidth: 1.16496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5893 5.87378C13.8126 5.87378 14.0268 5.94879 14.1847 6.0823C14.3426 6.21581 14.4314 6.39689 14.4314 6.5857V12.2811C14.4314 13.0363 14.0765 13.7606 13.4448 14.2947C12.8131 14.8287 11.9563 15.1287 11.063 15.1287H6.01036C5.11701 15.1287 4.26024 14.8287 3.62855 14.2947C2.99685 13.7606 2.64197 13.0363 2.64197 12.2811V6.5857C2.64197 6.39689 2.73069 6.21581 2.88861 6.0823C3.04654 5.94879 3.26073 5.87378 3.48407 5.87378H15.2735C16.1668 5.87378 17.0236 6.1738 17.6553 6.70784C18.287 7.24189 18.6418 7.96621 18.6418 8.72146C18.6418 9.47671 18.287 10.201 17.6553 10.7351C17.0236 11.2691 16.1668 11.5691 15.2735 11.5691H14.4314",
    stroke: "white",
    strokeWidth: 1.16496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16833 1.60229V3.02613",
    stroke: "white",
    strokeWidth: 1.16496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeChat);
export default __webpack_public_path__ + "static/media/coffee-chat.863fdb5b32b3a7395c7b27bd04105548.svg";
export { ForwardRef as ReactComponent };